<script lang="ts">export let size = "20";
const height = size;
</script>

<svg {height} style="fill: currentColor" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
	<path d="M8 14A6 6 0 1 1 8 2a6 6 0 0 1 0 12m-.6-4.2V11h1.2V9.8zm0-4.8v3.6h1.2V5z" />
</svg>
